import { render, staticRenderFns } from "./r-circle-block.vue?vue&type=template&id=0a8ee82a"
import script from "./r-circle-block.vue?vue&type=script&lang=js"
export * from "./r-circle-block.vue?vue&type=script&lang=js"
import style0 from "./r-circle-block.vue?vue&type=style&index=0&id=0a8ee82a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports